import NoItems from "PFApp/components/table/no_items";
import { LoadingDots } from "PFComponents/loading_dots";
import { fetchPaginatedCollection } from "PFCore/helpers/collection";
import { useDeterministicStringify } from "PFCore/helpers/use_deterministic_stringity";
import { ApiRoute } from "PFCore/utilities/routes";
import DownArrow from "PFIcons/down_arrow.svg";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { getAPIFilters, handleRequestFiltersChange } from "../../use_filtered_collection/format_filters";
import EngagementsRowsConnected from "./engagements/engagements_rows_connected";
import css from "./group.module.scss";
import Pagination from "./pagination";
import RolesRowsConnected from "./roles/roles_rows_connected";
import SelectGroups from "./select_groups";

const Group = ({
  type,
  group,
  filter,
  valueFilters,
  selectedOrder,
  groups,
  selectedGroups,
  onGroupSelected
}) => {
  const { t } = useTranslation();
  const stringify = useDeterministicStringify();
  const [collection, setCollection] = useState({ entries: [], meta: {} });
  const [loading, setLoading] = useState(true);

  const RowsComponent = {
    engagements: EngagementsRowsConnected,
    roles: RolesRowsConnected
  }[type];

  const fetchData = (page) => {
    setLoading(true);
    const newFilters = group
      ? handleRequestFiltersChange(valueFilters, filter, group.id)
      : { ...valueFilters };

    fetchPaginatedCollection(ApiRoute(`/api/${type}`), {
      filters: getAPIFilters(newFilters),
      order: selectedOrder,
      page,
      perPage: 7
    }).then((response) => {
      setCollection(response);
      setLoading(false);
    });
  };

  useEffect(() => {
    fetchData();
  }, [stringify(getAPIFilters(valueFilters))]);

  const noItems = collection.meta.total === 0;

  return (
    <div>
      <div className={css.header}>
        {group ? (
          <SelectGroups
            group={group}
            groups={groups}
            selectedGroups={selectedGroups}
            onGroupSelected={onGroupSelected}
          />
        ) : (
          <div className={css.title}>
            <span>{t("all")}</span>
            <DownArrow height={18} width={18} />
          </div>
        )}
        <Pagination
          className={css.pagination}
          page={collection.meta.page}
          onClick={(number) => fetchData(number)}
          total={collection.meta.total}
          perPage={collection.meta.perPage}
        />
      </div>
      {loading && collection.entries.length === 0 ? (
        <LoadingDots circlesEnabled pageViewEnabled />
      ) : (
        <>
          {noItems && <NoItems />}
          <RowsComponent items={collection.entries.map(({ activity }) => activity)} isLoading={loading} />
        </>
      )}
    </div>
  );
};

Group.propTypes = {
  type: PropTypes.oneOf(["engagements", "roles"]).isRequired,
  group: PropTypes.shape({
    id: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
    selected: PropTypes.bool.isRequired
  }),
  groups: PropTypes.array,
  selectedGroups: PropTypes.array,
  onGroupSelected: PropTypes.func,
  filter: PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  }).isRequired,
  valueFilters: PropTypes.object.isRequired,
  selectedOrder: PropTypes.object
};

export default Group;
